import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'

import FastClick from 'fastclick'
import VueLazyload from 'vue-lazyload'
import interfaces from 'api/api'
import 'utils/filter';
import { Collapse, CollapseItem, Tab, Tabs, Tabbar, GridItem, Grid, Area, AddressEdit, TabbarItem, RadioGroup, Radio, Row, Col, Button, Dialog, Toast, NavBar, Icon, Field, Overlay, Image, Uploader, Loading, Calendar, Checkbox, PullRefresh, Popup, DatetimePicker, Cell, List, Swipe, SwipeItem, Lazyload, Sku, Switch, ActionSheet, Search, step, steps } from 'vant';
import { CODE_OK } from 'utils/publicData'
import './guard.js'
import 'animate.css'
import '@/styles/index.less' // global css

import "babel-polyfill"
import 'lib-flexible/flexible.js'

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.use(Row)
  .use(Col)
  .use(Button)
  .use(Dialog)
  .use(Toast)
  .use(NavBar)
  .use(Icon)
  .use(Field)
  .use(Overlay)
  .use(Image)
  .use(Uploader)
  .use(Loading)
  .use(Calendar)
  .use(Checkbox)
  .use(List)
  .use(Cell)
  .use(PullRefresh)
  .use(Popup)
  .use(DatetimePicker)
  .use(RadioGroup)
  .use(Radio)
  .use(Tab)
  .use(Tabs)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Swipe)
  .use(SwipeItem)
  .use(Lazyload)
  .use(Sku)
  .use(Switch)
  .use(ActionSheet)
  .use(Search)
  .use(AddressEdit)
  .use(Area)
  .use(Grid)
  .use(GridItem)
  .use(step)
  .use(steps)
  .use(Collapse)
  .use(CollapseItem)
// FastClick.attach(document.body) // 300 秒延迟
// 修复点击300ms延迟
if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', () => {
    FastClick.attach(document.body)
  }, false)
}
FastClick.prototype.focus = function (targetElement) {
  targetElement.focus();
};

Vue.use(VueLazyload, {
  loading: require('@/assets/img/defalut-logo.png')
})

window.addEventListener('popstate', function (e) {
  router.isBack = true
}, false)

function ready () {
  console.log(window.__wxjs_environment === 'miniprogram') // true
}
if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
  document.addEventListener('WeixinJSBridgeReady', ready, false)
} else {
  ready()
}

/* eslint-disable no-unused-vars */
// import Console from 'vconsole'
// const Vconsole = new Console();
// Vue.config.productionTip = false

Vue.prototype.$api = interfaces
Vue.prototype.CODE_OK = CODE_OK

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

